export const HOW_IT_WORKS_ASSETS_PREFIX = '/assets/how-it-works'
export const SAFETY_ASSETS_PREFIX = '/assets/images/safety'
